module.exports = __webpack_public_path__ + "img/ETLogoBlue.ffc9f17f.png";